import React from 'react'
import PropTypes from 'prop-types'
import { AutoFetchFilter } from '@morningtrain/react-filters'
import Selection from './selections/Selection'
import CollectionPayload from './CollectionPayload'
import { ConstrainableOperation } from './constraining'

function Collection (props) {
  const operationProps = {
    namespace: props.namespace,
    resourceName: props.resourceName,
    operationName: props.operationName,
    operationContext: props.operationContext,
    persist: props.persist,
    provideErrors: props.provideErrors,
    useParentConstrainable: props.useParentConstrainable
  }

  return (
    <ConstrainableOperation {...operationProps}>
      <CollectionPayload>
        <Selection>
          <>
            {props.children}
            {props.autoFetch ? <AutoFetchFilter /> : null}
          </>
        </Selection>
      </CollectionPayload>
    </ConstrainableOperation>
  )
}

Collection.defaultProps = {
  namespace: 'api',
  operationName: 'index',
  operationContext: {},
  persist: false,
  autoFetch: true,
  provideErrors: true,
  useParentConstrainable: false
}

Collection.propTypes = {
  namespace: PropTypes.string,
  resourceName: PropTypes.string,
  operationName: PropTypes.string,
  operationContext: PropTypes.object,
  persist: PropTypes.bool,
  autoFetch: PropTypes.bool,
  provideErrors: PropTypes.bool,
  useParentConstrainable: PropTypes.bool
}

export default Collection
